import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm, ValidatedBlobField } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { IPlanCategory } from 'app/shared/model/plan-category.model';
import { getEntities as getPlanCategories } from 'app/entities/plan-category/plan-category.reducer';
import { IPlans } from 'app/shared/model/plans.model';
import { getEntity, updateEntity, createEntity, reset } from './plans.reducer';

export const PlansUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const planCategories = useAppSelector(state => state.planCategory.entities);
  const plansEntity = useAppSelector(state => state.plans.entity);
  const loading = useAppSelector(state => state.plans.loading);
  const updating = useAppSelector(state => state.plans.updating);
  const updateSuccess = useAppSelector(state => state.plans.updateSuccess);

  const handleClose = () => {
    navigate('/plans' + location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getPlanCategories({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  // eslint-disable-next-line complexity
  const saveEntity = values => {
    if (values.id !== undefined && typeof values.id !== 'number') {
      values.id = Number(values.id);
    }
    if (values.planPrice !== undefined && typeof values.planPrice !== 'number') {
      values.planPrice = Number(values.planPrice);
    }

    const entity = {
      ...plansEntity,
      ...values,
      planCategory: planCategories.find(it => it.id.toString() === values.planCategory.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...plansEntity,
          planCategory: plansEntity?.planCategory?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="fitengineerBackendV2App.plans.home.createOrEditLabel" data-cy="PlansCreateUpdateHeading">
            <Translate contentKey="fitengineerBackendV2App.plans.home.createOrEditLabel">Create or edit a Plans</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="plans-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('fitengineerBackendV2App.plans.planTitle')}
                id="plans-planTitle"
                name="planTitle"
                data-cy="planTitle"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('fitengineerBackendV2App.plans.planPrice')}
                id="plans-planPrice"
                name="planPrice"
                data-cy="planPrice"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('fitengineerBackendV2App.plans.planDescription')}
                id="plans-planDescription"
                name="planDescription"
                data-cy="planDescription"
                type="textarea"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedBlobField
                label={translate('fitengineerBackendV2App.plans.planLogo')}
                id="plans-planLogo"
                name="planLogo"
                data-cy="planLogo"
                isImage
                accept="image/*"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('fitengineerBackendV2App.plans.planSuitableFor')}
                id="plans-planSuitableFor"
                name="planSuitableFor"
                data-cy="planSuitableFor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                id="plans-planCategory"
                name="planCategory"
                data-cy="planCategory"
                label={translate('fitengineerBackendV2App.plans.planCategory')}
                type="select"
                required
              >
                <option value="" key="0" />
                {planCategories
                  ? planCategories.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.planCategory}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/plans" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PlansUpdate;
